import blantyreLogo from './club-blantyre-united.png';
import glasgowOnTheBallLogo from './club-glasgow-on-the-ball.png';
import haghillLogo from './club-haghill-afc.png';
import hillwoodLogo from './club-hillwood-afc.png';
import kelburneLogo from './club-kelburne-afc.png';
import maryhillBlackStarLogo from './club-maryhill-black-star.png';
import maryhillMilanLogo from './club-maryhill-milan.png';
import pollokshieldsLogo from './club-pollokshields-united.png';
import poloniaLogo from './club-polonia-glasgow.png';
import todholmLogo from './club-todholm-afc.png';
import yokerLogo from './club-yoker-athletic.png';

export type BundledLeagueClub = {
  key: string;
  canonicalName: string;
  displayName: string;
  logo: string;
  aliases: string[];
  sortOrder: number;
  primaryColor: string;
  secondaryColor: string;
  shortName: string;
};

export const PREMIERSHIP_CLUBS: BundledLeagueClub[] = [
  {
    key: 'blantyre-united',
    canonicalName: 'Blantyre Utd',
    displayName: 'Blantyre United',
    logo: blantyreLogo,
    aliases: ['blantyre united', 'blantyre utd', 'blantyre united fc'],
    sortOrder: 1,
    primaryColor: '#0a0a0a',
    secondaryColor: '#f2f2f2',
    shortName: 'Blantyre',
  },
  {
    key: 'glasgow-on-the-ball',
    canonicalName: 'Glasgow On The Ball',
    displayName: 'Glasgow On The Ball',
    logo: glasgowOnTheBallLogo,
    aliases: ['glasgow on the ball', 'africa on the ball', 'africa on the ball fc'],
    sortOrder: 2,
    primaryColor: '#1f6c2c',
    secondaryColor: '#ffffff',
    shortName: 'GOTB',
  },
  {
    key: 'haghill-afc',
    canonicalName: 'Haghill AFC',
    displayName: 'Haghill AFC',
    logo: haghillLogo,
    aliases: ['haghill afc', 'haghill fc', 'haghill'],
    sortOrder: 3,
    primaryColor: '#1833c5',
    secondaryColor: '#d9e2ff',
    shortName: 'Haghill',
  },
  {
    key: 'hillwood-afc',
    canonicalName: 'Hillwood AFC',
    displayName: 'Hillwood AFC',
    logo: hillwoodLogo,
    aliases: ['hillwood afc', 'hillwood fc', 'hillwood'],
    sortOrder: 4,
    primaryColor: '#2e236f',
    secondaryColor: '#ffffff',
    shortName: 'Hillwood',
  },
  {
    key: 'kelburne-afc',
    canonicalName: 'Kelburne AFC',
    displayName: 'Kelburne AFC',
    logo: kelburneLogo,
    aliases: ['kelburne afc', 'kelburne fc', 'kelburne'],
    sortOrder: 5,
    primaryColor: '#111111',
    secondaryColor: '#e7e7e7',
    shortName: 'Kelburne',
  },
  {
    key: 'maryhill-black-star',
    canonicalName: 'Maryhill Black Star',
    displayName: 'Maryhill Black Star',
    logo: maryhillBlackStarLogo,
    aliases: ['maryhill black star', 'maryhill blackstar', 'black star'],
    sortOrder: 6,
    primaryColor: '#111111',
    secondaryColor: '#d9b25f',
    shortName: 'Black Star',
  },
  {
    key: 'maryhill-milan',
    canonicalName: 'Maryhill Milan',
    displayName: 'Maryhill Milan',
    logo: maryhillMilanLogo,
    aliases: ['maryhill milan', 'maryhill milan afc'],
    sortOrder: 7,
    primaryColor: '#d93324',
    secondaryColor: '#ffffff',
    shortName: 'Maryhill Milan',
  },
  {
    key: 'pollokshields-united',
    canonicalName: 'Pollokshields Utd',
    displayName: 'Pollokshields United',
    logo: pollokshieldsLogo,
    aliases: ['pollokshields united', 'pollokshields utd', 'pollokshields'],
    sortOrder: 8,
    primaryColor: '#10213d',
    secondaryColor: '#d2a745',
    shortName: 'Pollokshields',
  },
  {
    key: 'polonia-glasgow',
    canonicalName: 'Polonia Glasgow',
    displayName: 'Polonia Glasgow AFC',
    logo: poloniaLogo,
    aliases: ['polonia glasgow', 'polonia glasgow afc', 'afc polonia glasgow', 'polonia'],
    sortOrder: 9,
    primaryColor: '#0756c9',
    secondaryColor: '#f4c542',
    shortName: 'Polonia',
  },
  {
    key: 'todholm-afc',
    canonicalName: 'Todholm AFC',
    displayName: 'Todholm AFC',
    logo: todholmLogo,
    aliases: ['todholm afc', 'todholm amateurs', 'todholm'],
    sortOrder: 10,
    primaryColor: '#61216e',
    secondaryColor: '#d78cf0',
    shortName: 'Todholm',
  },
  {
    key: 'yoker-athletic',
    canonicalName: 'Yoker Athletic Sun',
    displayName: 'Yoker Athletic FC',
    logo: yokerLogo,
    aliases: ['yoker athletic sun', 'yoker athletic fc', 'yoker athletic', 'yoker'],
    sortOrder: 11,
    primaryColor: '#18306e',
    secondaryColor: '#ffffff',
    shortName: 'Yoker',
  },
];

export function normalizeClubName(value?: string | null) {
  return (value || '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\b(afc|fc|football club|amateurs|sun)\b/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function resolveBundledClub(value?: string | null) {
  const normalized = normalizeClubName(value);
  if (!normalized) return null;

  return (
    PREMIERSHIP_CLUBS.find((club) =>
      [club.canonicalName, club.displayName, ...club.aliases]
        .map(normalizeClubName)
        .includes(normalized),
    ) ||
    PREMIERSHIP_CLUBS.find((club) => {
      const candidates = [club.canonicalName, club.displayName, ...club.aliases]
        .map(normalizeClubName);
      return candidates.some(
        (candidate) =>
          normalized.includes(candidate) ||
          candidate.includes(normalized),
      );
    }) ||
    null
  );
}
